import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private _accessToken = signal('');
  readonly accessToken = this._accessToken.asReadonly();

  set(token: string): void {
    this._accessToken.set(token);
  }
}
